export const TUPA25FeatureFlags = {
    enabledFeatures: [],
    initialized: false,

    init(features) {
        if (Array.isArray(features)) {
            this.enabledFeatures = features;
        } else if (features === undefined || features === null) {
            this.loadFromCookie();
        } else {
            console.warn('Invalid features parameter passed to init:', features);
            this.loadFromCookie();
        }
        this.initialized = true;
    },

    loadFromCookie() {
        try {
            const cookieName = 'tupa25_features';
            const cookieValue = commonUtils.getCookie(cookieName); // Ensure commonUtils is defined

            if (cookieValue) {
                this.enabledFeatures = cookieValue.split(',').filter(Boolean);
            }
        } catch (e) {
            console.error('Error loading TUPA25 features from cookie:', e);
            this.enabledFeatures = [];
        }
    },

    isEnabled(feature) {
        if (!this.initialized) {
            this.init([]);
        }
        return this.enabledFeatures.includes(feature);
    },

    getEnabledFeatures() {
        if (!this.initialized) {
            this.init([]);
        }
        return [...this.enabledFeatures];
    },
};

$(function () {
    const features = globalThis.TUPA25_FEATURES || [];
    TUPA25FeatureFlags.init(features);

    const enabledFeatures = TUPA25FeatureFlags.getEnabledFeatures();
    console.info('Enabled features:', enabledFeatures);
});
